import { render } from "./GoalGauge.vue?vue&type=template&id=74473b24"
import script from "./GoalGauge.vue?vue&type=script&lang=js"
export * from "./GoalGauge.vue?vue&type=script&lang=js"
script.render = render

export default script